// apps-keyboard-integration.js
// This file shows the changes needed to integrate keyboard navigation

/*
 * STEP 1: Add this import to apps.html (after apps-slider.js, before apps.js)
 * <script type="module" src="/api/static/js/apps-kb-main.js"></script>
 */

/*
 * STEP 2: In apps.js, add this import at the top with the other imports:
 * import * as keyboard from './apps-kb-main.js';
 */

/*
 * STEP 3: In apps.js, in the loadUserInfo() or after loadIcons() completes,
 * add this initialization call:
 * 
 * keyboard.initKeyboardNavigation();
 */

/* 
 * STEP 4: In apps-folders.js, add these imports at the top:
 * import * as keyboard from './apps-kb-main.js';
 */

/*
 * STEP 5: In apps-folders.js, in the openFolderView() function,
 * add this at the END of the function (after attachFolderEventListeners()):
 * 
 * keyboard.onFolderOpen();
 */

/*
 * STEP 6: In apps-folders.js, in the closeFolderView() function,
 * add this at the END of the function (after classList.remove('open')):
 * 
 * keyboard.onFolderClose();
 */

// ==================================================================
// COMPLETE UPDATED CODE SECTIONS
// ==================================================================

// ============ apps.html COMPLETE <head> section with scripts ============
/*
<!-- Add after apps-slider.js line -->
<script type="module" src="/api/static/js/apps-kb-main.js"></script>
*/

// ============ apps.js UPDATED loadUserInfo function ============
/*
export async function loadUserInfo() {
    try {
        const response = await fetch(`${API_BASE}/account/info`, {
            credentials: 'include'
        });
        
        if (response.ok) {
            const data = await response.json();
            window.currentUserId = data.user.id;
            
            document.getElementById('headerUsername').textContent = 
                data.user.display_name || data.user.username;
            
            document.querySelectorAll('.logged-in-content').forEach(el => {
                el.style.display = '';
            });
            document.querySelectorAll('.logged-out-content').forEach(el => {
                el.style.display = 'none';
            });
            
            initNavigation('apps');

            await loadIcons();
            
            // Initialize keyboard navigation after everything is loaded
            const { initKeyboardNavigation } = await import('./apps-kb-main.js');
            initKeyboardNavigation();
            
        } else {
            document.querySelectorAll('.logged-in-content').forEach(el => {
                el.style.display = 'none';
            });
            document.querySelectorAll('.logged-out-content').forEach(el => {
                el.style.display = '';
            });
            
            showLoggedOutState();
            console.log('Not logged in - loading mock data for development/testing');
            window.currentUserId = 0;
            document.querySelector('.appspace-container').style.display = '';
            initNavigation('apps');
            await loadIcons();
            
            // Initialize keyboard navigation for logged out users too
            const { initKeyboardNavigation } = await import('./apps-kb-main.js');
            initKeyboardNavigation();
        }
    } catch (error) {
        console.error('Error loading user info:', error);
        showLoggedOutState();
        console.log('API error - loading mock data for development/testing');
        window.currentUserId = 0;
        document.querySelector('.appspace-container').style.display = '';
        initNavigation('apps');
        await loadIcons();
        
        // Initialize keyboard navigation in error case too
        const { initKeyboardNavigation } = await import('./apps-kb-main.js');
        initKeyboardNavigation();
    }
}
*/

// ============ apps-folders.js UPDATED openFolderView function ============
/*
export function openFolderView(folder) {
    state.openFolder = folder;
    state.currentFolderScreen = 0;
    const folderIcons = window.icons.filter(icon => icon.kfolder === folder.id);
    
    // ... existing code ...
    
    attachFolderEventListeners();
    setupFolderTitleEditing();
    
    // NEW: Initialize keyboard cursor in folder
    import('./apps-kb-main.js').then(keyboard => {
        keyboard.onFolderOpen();
    });
}
*/

// ============ apps-folders.js UPDATED closeFolderView function ============
/*
export function closeFolderView() {
    if (!state.openFolder) return;
    
    // NEW: Store folder ID before clearing
    const closedFolderId = state.openFolder.id;
    
    state.openFolder = null;
    
    document.querySelector('.appspace-container').classList.remove('folder-open');
    document.getElementById('folderOverlay').classList.remove('open');
    
    // NEW: Handle keyboard cursor positioning
    import('./apps-kb-main.js').then(keyboard => {
        keyboard.onFolderClose();
    });
    
    updateSliderVisibility();
}
*/

// ==================================================================
// ALTERNATIVE: SIMPLER INTEGRATION
// If you prefer to minimize changes to existing files, you can
// create this wrapper file and import it in apps.html
// ==================================================================

export async function autoIntegrateKeyboard() {
    // Wait for DOM and icons to load
    if (!window.icons || !document.getElementById('appspaceViewport')) {
        setTimeout(autoIntegrateKeyboard, 100);
        return;
    }
    
    // Import and initialize
    const keyboard = await import('./apps-kb-main.js');
    keyboard.initKeyboardNavigation();
    
    console.log('Keyboard navigation auto-integrated');
}

// For the simplest integration, just add this to apps.html:
// <script type="module">
//     import { autoIntegrateKeyboard } from './apps-keyboard-integration.js';
//     autoIntegrateKeyboard();
// </script>
